/** @file toPuppetEvents: pose's event reports tagged with the clip name, in order. */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { EventReport } from '@zilo/pose3d-pose/events/eventTypes';
import type { PuppetEvent } from '@zilo/pose3d-runtime-babylon/clip/clipClockTypes';

/** One `PuppetEvent` per report, `clip` = `clip.name`. */
export function toPuppetEvents(reports: readonly EventReport[], clip: Clip): PuppetEvent[] {
  return reports.map((r) => ({ ...r, clip: clip.name }));
}
